module.exports = __webpack_public_path__ + "media/images/hodzzy-cover-bg-da0d42f2bbf7b6dd55884f44f9cf8c5f.png";